import { combineReducers } from '@reduxjs/toolkit'

import orderDonorCoveredFeesSlice from '../dcf/order-donor-covered-fees-slice'
import orderFrequencySlice from '../frequency/order-frequency-slice'
import orderAmountSlice from '../amount/order-amount-slice'
import orderCurrencySlice from '../currency/order-currency-slice'
import orderDedicationSlice from '../dedication/order-dedication-slice'
import orderCommentSlice from '../comment/order-comment-slice'

import paymentDetailsReducer from 'redux/features/paymentDetails'
import stripePaymentRequestReducer from 'redux/features/stripePaymentRequest'
import { transactionSlice } from 'redux/features/transaction'
import orderDesignationSlice from '../designation/order-designation-slice'
import orderDoubleTheDonationSlice from '../double-the-donation/order-double-the-donation-slice'
import orderAddressSlice from '../address/address-slice'
import orderContactSlice from '../contact/contact-slice'
import orderContactAnswersSlice from '../contact-answers/contact-answers-slice'
import orderCustomAnswersSlice from '../custom-answers/custom-answers-slice'
import orderRecurringEndDateSlice from '../recurring-end-date/order-recurring-end-date-slice'

const orderReducers = combineReducers({
  dcf: orderDonorCoveredFeesSlice.reducer,
  frequency: orderFrequencySlice.reducer,
  recurringEndDate: orderRecurringEndDateSlice.reducer,
  amount: orderAmountSlice.reducer,
  currency: orderCurrencySlice.reducer,
  address: orderAddressSlice.reducer,
  contact: orderContactSlice.reducer,
  contactAnswers: orderContactAnswersSlice.reducer,
  customAnswers: orderCustomAnswersSlice.reducer,
  comment: orderCommentSlice.reducer,
  dedication: orderDedicationSlice.reducer,
  designation: orderDesignationSlice.reducer,
  doubleTheDonation: orderDoubleTheDonationSlice.reducer,
  paymentDetails: paymentDetailsReducer,
  stripePaymentRequest: stripePaymentRequestReducer,
  transaction: transactionSlice.reducer,
})

export default orderReducers
